import { ReactElement } from 'react';
import omit from 'lodash/omit';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from 'hooks/StyledComponents';
import { useField, useFormikContext } from 'formik';

// Core + Store
import { IFacetProps, SearchRequest } from 'components/ContinuousImprovement/Facets/types';

// Types
interface ICheckboxProps {
  callback?(): void;
  label: string;
  name: string;
  type: 'checkbox';
  value: boolean;
}
const Checkbox = ({ label, value, callback, ...props }: ICheckboxProps): ReactElement => {
  const [field, , helpers] = useField(props.name);
  const { values, setValues } = useFormikContext<SearchRequest>();
  const { setValue } = helpers;
  const isChecked = values[props.name] === value;

  const onChange = (): void => {
    if (isChecked) {
      setValues(omit(values, field.name));
      callback?.();
    } else {
      setValue(value);
      callback?.();
    }
  };

  return (
    <>
      <label className="form-input-checkbox">
        <input {...field} {...props} checked={isChecked} onChange={onChange} />
        <span className="checkmark">
          <div className="label-text-container">
            <div className="label-text">{label}</div>
          </div>
        </span>
      </label>
    </>
  );
};

export const BooleanCheckboxes = (props: IFacetProps): ReactElement => {
  const { facet, facets, isDisabled, isExpanded, expandIcon, onToggleExpand } = props;

  const { displayValue, payloadValue, responseValue } = facet;

  return (
    (facets?.[responseValue] && (
      <StyledAccordion key={payloadValue} disabled={isDisabled} expanded={isExpanded} onChange={onToggleExpand}>
        <StyledAccordionSummary
          aria-controls={`${payloadValue}-content`}
          expandIcon={expandIcon}
          id={`${payloadValue}-header`}
        >
          {displayValue}
        </StyledAccordionSummary>
        <StyledAccordionDetails role="group" aria-labelledby={`${payloadValue}-header`}>
          <Checkbox name={payloadValue} value={!!payloadValue} type="checkbox" label="Yes" />
          <Checkbox name={payloadValue} value={false} type="checkbox" label="No" />
        </StyledAccordionDetails>
      </StyledAccordion>
    )) ||
    null
  );
};
